import { render, staticRenderFns } from "./problem-report-footer.vue?vue&type=template&id=f89fec2e"
import script from "./problem-report-footer.vue?vue&type=script&lang=js"
export * from "./problem-report-footer.vue?vue&type=script&lang=js"
import style0 from "./problem-report-footer.vue?vue&type=style&index=0&id=f89fec2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports